import UUIDBase from '../UUIDBase'

export class Terminal extends UUIDBase {
  static ENDPOINT = '/company/terminals'

  enName = ''
  arName = ''
  epaymentDestinationAccountID = ''
  destinationAccountName = ''

  static from(json: Record<string, unknown> | Terminal): Terminal {
    return Object.assign(new Terminal(), json)
  }
}

export class RegisterTerminal extends UUIDBase {
  registerID = ''
  terminalID = ''
  terminal = new Terminal()
  enabled = true

  static from(json: Record<string, unknown> | RegisterTerminal): RegisterTerminal {
    const o = Object.assign(new RegisterTerminal(), json)
    o.terminal = Terminal.from(o.terminal || {})
    return o
  }
}
